// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"79":"256230d3","233":"cfc0505b","299":"4a75213f","540":"3087d3a1","545":"5944ac7b","961":"dc457c17"}[chunkId] + ".chunk.js";
};